import { automatedActionApiV2 } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const automatedActionCriteriaSchema = new schema.Entity(
  'data',
  {},
  {
    processStrategy: ({ id, parentId, criteria, companyId, isDisabledForCompany, ...rest }) => ({
      ...rest,
      criteriaId: id,
      parentCriteriaId: parentId || null,
      companyId,
      isDisabledForCompany,
      expression: criteria?.expression,
      userFriendlyExpression: criteria?.userFriendlyExpression,
    }),
  },
);

export const AUTOMATED_ACTION_CRITERIA_ACTION_TYPE = createNamedActions('automatedActionCriteria', {
  GET_AUTOMATED_ACTIONS: 'GET_AUTOMATED_ACTIONS',
  GET_AUTOMATED_ACTIONS_SCHEMA: 'GET_AUTOMATED_ACTIONS_SCHEMA',
  CREATE_AUTOMATED_ACTION: 'CREATE_AUTOMATED_ACTION',
  EDIT_AUTOMATED_ACTION: 'EDIT_AUTOMATED_ACTION',
  CHANGE_ACTION_ORDER: 'CHANGE_ACTION_ORDER',
  DISABLE_GLOBAL_ACTION: 'DISABLE_GLOBAL_ACTION',
  ENABLE_GLOBAL_ACTION: 'ENABLE_GLOBAL_ACTION',
  CLONE_GLOBAL_ACTION: 'CLONE_GLOBAL_ACTION',
});

export const getAutomatedActionCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await automatedActionApiV2.getAutomatedActions(params);

  return dispatch({
    type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.GET_AUTOMATED_ACTIONS,
    payload: normalize(data, [automatedActionCriteriaSchema]).entities.data,
  });
});

export const getAutomatedActionCriteriaSchemaAction = catchAsyncActionError(
  ({ targetType } = {}) =>
    async dispatch => {
      const { data } = await automatedActionApiV2.getAutomatedActionsExpressionDefinition({
        targetType,
      });

      return dispatch({
        type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.GET_AUTOMATED_ACTIONS_SCHEMA,
        payload: data,
      });
    },
);

export const createAutomatedActionCriteriaAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await automatedActionApiV2.createAutomatedAction(params);

    const normalizedData = normalize(data, automatedActionCriteriaSchema);

    return dispatch({
      type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.CREATE_AUTOMATED_ACTION,
      payload: normalizedData.entities.data[normalizedData.result],
    });
  },
);

export const editAutomatedActionCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await automatedActionApiV2.editAutomatedAction(params);

  const normalizedData = normalize(data, automatedActionCriteriaSchema);

  return dispatch({
    type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.EDIT_AUTOMATED_ACTION,
    payload: normalizedData.entities.data[normalizedData.result],
  });
});

export const deleteAutomatedActionCriteriaAction = catchAsyncActionError(
  params => async dispatch => {
    await automatedActionApiV2.deleteAutomatedAction(params);

    await dispatch(getAutomatedActionCriteriaAction({ includeGlobalEntities: true }));
  },
);

export const disableGlobalAutomatedActionAction = catchAsyncActionError(
  params => async dispatch => {
    await automatedActionApiV2.disableGlobalAutomatedAction(params);

    return dispatch({
      type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.DISABLE_GLOBAL_ACTION,
      meta: params,
    });
  },
);

export const enableGlobalAutomatedActionAction = catchAsyncActionError(params => async dispatch => {
  await automatedActionApiV2.enableGlobalAutomatedAction(params);

  return dispatch({
    type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.ENABLE_GLOBAL_ACTION,
    meta: params,
  });
});

export const cloneGlobalAutomatedActionAction = catchAsyncActionError(params => async dispatch => {
  await automatedActionApiV2.cloneGlobalAutomatedAction(params);

  return dispatch({
    type: AUTOMATED_ACTION_CRITERIA_ACTION_TYPE.CLONE_GLOBAL_ACTION,
    meta: params,
  });
});
